/**
 * @function setCookie 设置cookie
 * @function getCookie 获取cookie
 * @function delCookie 删除cookie
 * @function getToken 获取当前用户信息
 * @function user 获取当前用户信息
 */

import { myAlert } from './my'
import { getFullPath } from './operate'
import { clearAdminAccessFlag } from '@/utils/global/adminAccess'
import { logout } from '@/apis/login/index'
const loginUrl =
	import.meta.env.MODE === 'cnki' ? process.env.VITE_APP_LOGIN_URL : process.env.VITE_APP_LOGIN_URL + '&prompt=login'
const isCnki = import.meta.env.MODE === 'cnki'

// import dayjs from "dayjs"

/**
 * @description 设置cookie
 * @param name string 名称
 * @param value string 值
 * @param expiredays number 过期天数 默认3天 or string 到期时间
 */
export const setCookie = (name: string, value: string, expiredays: number | string = 3): void => {
	let time = ''
	if (typeof expiredays === 'number') {
		const d = new Date()
		d.setTime(d.getTime() + expiredays * 24 * 60 * 60 * 1000)
		time = d.toUTCString()
	} else {
		time = expiredays
	}
	document.cookie = `${name}=${value};expires=${time};path=/`
}

/**
 * @description 获取cookie
 * @param name string cookie名称
 */
export const getCookie = (name: string): string => {
	const cookieArr = document.cookie.split(';')
	for (let i = 0; i < cookieArr.length; i++) {
		const c = cookieArr[i].trim()
		if (c.indexOf(name) === 0) {
			return c.substring(name.length + 1, c.length)
		}
	}
	return ''
}
/**
 * @description 删除cookie
 */
export const delCookie = (name: string): void => {
	setCookie(name, '', -1)
}
/**
 * @description 删除cookie
 */
export const delAllCookie = (): void => {
	for (const i in process.env) {
		if (i?.includes('Cookie')) {
			const cookieName = process.env[i] as string
			delCookie(cookieName)
		}
	}
	for (const i in process.env) {
		if (i?.includes('Local')) {
			localStorage.removeItem(process.env[i] as string)
		}
	}
	localStorage.removeItem('menuClose')
	let domain = '*'
	if (process.env.VITE_APP_PROD === 'true') {
		domain = '.thtf.com.cn'
	}
	document.cookie = `token=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${domain}`
}

/**
 * @description 设置token
 * @param value string token值
 * @param expiredays number 过期分钟
 */
export const setToken = (value: string, expiredays: number) => {
	let time = ''
	let time2 = ''
	if (expiredays) {
		const d = new Date()
		d.setTime(d.getTime() + expiredays * 60 * 1000)
		time2 = d.toLocaleString('zh-CN', { hour12: false })
		time = d.toUTCString()
	}
	setCookie(process.env.VITE_APP_Cookie_Token as string, value, time)
	setCookie('expires', time2, time)
}

/**
 * @description 设置pagecode
 */
// export const setPageCode = (value: string) => {
// 	// 设置会话存储
// 	const encodeValue = encodeURIComponent(value)
// 	sessionStorage.setItem("pageCode", encodeValue)
// }
/**
 * @description 设置activeResoure
 */
export const setActiveResoure = (value: string) => {
	// 设置会话存储
	const encodeValue = encodeURIComponent(JSON.stringify(value))
	sessionStorage.setItem('activeResoure', encodeValue)
}
/**
 * @description 设置activeResoure
 */
export const getActiveResoure = () => {
	// 获取会话存储
	return JSON.parse(decodeURIComponent(sessionStorage.getItem('activeResoure') as string))
}
/**
 * @description 设置user
 */
export const setUser = (value: NKmUser.UserInfo) => {
	const encodeValue = encodeURIComponent(JSON.stringify(value))
	setCookie(process.env.VITE_APP_Cookie_User as string, encodeValue)
}
/**
 * @description 获取token
 */
export const getToken = (): string => {
	if (isCnki) {
		return getCookie(import.meta.env.VITE_APP_CNKI_TOKEN_KEY as string)
	}
	return getCookie(process.env.VITE_APP_Cookie_Token as string)
}

/**
 * @description 获取PageCod
 */
// export const getPageCode = (): string => {
// 	// return getCookie(process.env.VITE_APP_Cookie_Page as string)
// 	return decodeURIComponent(sessionStorage.getItem("pageCode") as string)
// }
/**
 * @description 获取token到期日期expires
 */
export const getExpires = (): string => {
	return getCookie('expires')
}

/**
 * @description 获取当前用户信息user信息
 */
export const getUser = (): NKmUser.UserInfo => {
	const userObj = getCookie(process.env.VITE_APP_Cookie_User as string)
	if (userObj) {
		return JSON.parse(decodeURIComponent(userObj))
	} else {
		return {} as NKmUser.UserInfo
	}
}
export const exit = () => {
	logout(localStorage.getItem('refreshToken') || '', 'km')
	delAllCookie()
	clearAdminAccessFlag()
	localStorage.removeItem('refreshToken')
	if (import.meta.env.PROD) {
		window.location.href = loginUrl as string
	} else {
		window.open(getFullPath('/login'), '_self')
	}
}
